// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3pvfd","productName":"Table_productName__28V9D"};